
import { Vue, Options } from 'vue-class-component'

@Options({
  props: {
    iconName: {
      type: String,
      default: 'icon',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    viewBoxWidth: {
      type: [Number, String],
    },
    viewBoxHeight: {
      type: [Number, String],
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
  name: 'svgPage',
})
export default class SvgBase extends Vue {
  get viewBox() {
    const width = this.viewBoxWidth ? this.viewBoxWidth : this.width
    const height = this.viewBoxHeight ? this.viewBoxHeight : this.height
    return `0 0 ${width} ${height}`
  }
}
